import { useContext, createContext, useState } from "react";

interface Context {
	open: (flagBagId?: string) => void;
	close: () => void;
	reservedFormOpen: boolean;
	assigningFlagBagId?: string;
}
const ReservedFormContext = createContext<Context>(null);

const ReservedFormProvider = ({ children }) => {
	const [reservedFormOpen, setReservedFormOpen] = useState(false);
	const [assigningFlagBagId, setAssigningFlagBagId] = useState<string | undefined>();

	const open = (flagBagId?: string) => {
		setAssigningFlagBagId(flagBagId);
		setReservedFormOpen(true);
	};

	const close = () => {
		setReservedFormOpen(false);
		setAssigningFlagBagId(undefined);
	};

	const value: Context = { open, close, reservedFormOpen, assigningFlagBagId };

	return <ReservedFormContext.Provider value={value}>{children}</ReservedFormContext.Provider>;
};

export default ReservedFormProvider;

export const useReservedForm = () => {
	return useContext(ReservedFormContext);
};
